export const HUB_TITLE = 'Tournaments';

export const HUB_SECTION_TITLES = {
  live: 'Live',
  upcoming: 'Upcoming',
  past: 'Past',
} as const;

export const HUB_EMPTY_TITLE = 'No competitions yet';
export const HUB_EMPTY_SUBTITLE = 'New pools appear here as seasons kick off.';
export const HUB_ERROR_TITLE = "Couldn't load competitions";
export const HUB_ERROR_RETRY = 'Retry';
export const HUB_JOIN_HINT = 'Tap to play';
export const HUB_FINISHED_META_PREFIX = 'Finished';

export const HUB_HERO_EYEBROW = 'Up next';
export const HUB_HERO_EYEBROW_LIVE = 'Happening now';
export const HUB_HERO_CTA_UPCOMING = 'Make your picks';
export const HUB_HERO_CTA_LIVE = 'Play now';
export const HUB_COUNTDOWN_LABELS = { days: 'days', hours: 'hrs', minutes: 'min' } as const;
export const HUB_COUNTDOWN_CAPTION = 'until kickoff';
/** Refresh cadence for the hero countdown — minute precision, no per-second churn. */
export const HUB_COUNTDOWN_TICK_MS = 30_000;

/**
 * Lifecycle affordance (specs/competitions-hub-client Story 16). Deliberately not a date:
 * a start date is a promise, and the one we had been rendering was wrong.
 */
export const HUB_STATUS_LIVE_LABEL = 'Active';
/** The clock pill carries no text, so it carries this instead. */
export const HUB_STATUS_UPCOMING_ACCESSIBILITY = 'Starting soon';
export const HUB_STATUS_CLOCK_ICON_SIZE = 14;

/** Badge sizes per surface — passed explicitly so each stays pixel-identical to its design. */
export const HUB_CREST_SIZE = 44;
export const HUB_CREST_SIZE_COMPACT = 34;
export const HUB_CREST_LOGO_SIZE = 32;
export const HUB_CREST_LOGO_SIZE_COMPACT = 24;
export const HUB_HERO_CREST_SIZE = 58;
export const HUB_HERO_CREST_LOGO_SIZE = 38;

export const HUB_TEST_IDS = {
  screen: 'competitions-hub',
  section: (key: string) => `competitions-hub-section-${key}`,
  card: (id: string) => `competition-card-${id}`,
  hero: 'competitions-hub-hero',
  heroCta: 'competitions-hub-hero-cta',
  retry: 'competitions-hub-retry',
  skeleton: 'competitions-hub-skeleton',
  statusUpcoming: (id: string) => `competition-status-upcoming-${id}`,
  statusLive: (id: string) => `competition-status-live-${id}`,
  heroStatus: 'competitions-hub-hero-status',
} as const;
